<template>
    <div>
        <the-header>

            <template v-slot:title>
                {{ $route.meta.title }}
            </template>
            <template v-slot:search>
                <div class="search" ref="searchDiv">
                    <transition name="slide-down">
                        <input
                                v-if="search"
                                type="text"
                                v-model="searchText"
                                placeholder="Wyszukaj"
                                class="search__input"
                                autofocus
                                ref="searchInput"
                        />
                    </transition>
                    <img
                            v-if="search"
                            width="39px"
                            class="navbar__image search__close"
                            src="@/assets/close.svg"
                            alt="search"
                            @click="setSearch(false)"
                    >
                    <template v-else>
                        <img
                                width="30px"
                                class="navbar__image"
                                src="@/assets/search.svg"
                                alt="search"
                                @click="setSearch(true)"
                        >
                        Wyszukaj
                    </template>
                </div>
            </template>
            <template v-slot:deliveries>
                <p
                        v-if="toDelivery && totalDeliveries"
                        class="is-size-5"
                >
                    <b><span class="delivery__green">{{ timeNow }}</span></b> <strong> {{ toDelivery }}/{{
                    totalDeliveries }}</strong>
                </p>

            </template>
        </the-header>
        <section class="section">
            <div class="container code-search-container">
                <code-search-field />
            </div>
            <div
                    class="container"
                    v-if="codeSearchResults"
            >
                <div class="code-search-results-header">
                    <p class="is-size-6">
                        <strong>Wyniki wyszukiwania</strong>
                        <span class="tag is-success is-light">{{ codeSearchResults.length }}</span>
                    </p>
                </div>
                <the-delivery
                        v-for="(delivery, index) in codeSearchResults"
                        v-bind:key="'search-' + index"
                        :id="index"
                        :delivery="delivery"
                />
            </div>
            <div
                    class="container"
                    v-if="loadingStatus == 'loading' && !codeSearchResults"
            >
                <div class="columns">
                    <div class="column has-text-centered">
                        <br/>
                        <h1 class="title">Trwa pobieranie zamówień</h1>
                        <svg-icon
                                class="svg svg-icon--background svg-icon__icon--loader"
                                type="return"
                        />
                    </div>
                </div>
            </div>

            <div class="container" v-else-if="codeSearchStatus === 'noResults'">
                <div class="columns">
                    <div class="column has-text-centered">
                        <br/>
                        <h1 class="title">Brak wyników dla „{{ codeSearchQuery }}"</h1>
                        <svg-icon
                                class="svg svg-icon--background"
                                type="box"
                        />
                    </div>
                </div>
            </div>

            <div
                    class="container"
                    v-else-if="!codeSearchQuery && deliveries && deliveries.length > 0"
            >
                <the-delivery
                        v-for="(delivery, index) in deliveries"
                        v-bind:key="index"
                        :id="index"
                        :delivery="delivery"
                />
                <div style="text-align: center; margin-top: 25px" v-if="responseDate">
                    Dane pobrano: {{responseDate}}
                </div>
            </div>
            <div class="container" v-else-if="!codeSearchQuery">
                <div class="columns">
                    <div class="column has-text-centered">
                        <br/>
                        <h1 class="title">Brak zamowień do dostarczenia</h1>
                        <svg-icon
                                class="svg svg-icon--background"
                                type="box"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import TheHeader from '@/components/TheHeader'
    import TheDelivery from '@/components/TheDelivery'
    import SvgIcon from '@/components/SvgIcon'
    import CodeSearchField from '@/components/CodeSearchField'

    export default {
        name: 'Deliveries',
        components: {
            'the-delivery': TheDelivery,
            'the-header': TheHeader,
            'svg-icon': SvgIcon,
            'code-search-field': CodeSearchField
        },
        metaInfo: {
            title: 'Do dostarczenia'
        },
        data() {
            return {
                showModal: true,
                search: false,
                searchText: '',
                state: "close"
            }
        },
        computed: {
            loadingStatus() {
                return this.$store.getters.getLoadingStatus
            },
            deliveries() {
                if (this.searchText !== '') {
                    let searchTxt = window.unaccent(this.searchText);
                    return this.$store.getters.getDeliveries.filter(delivery =>
                        (delivery.client_details.unaccent_name.toLowerCase().includes(searchTxt)
                            || delivery.client_details.unaccent_adress.toLowerCase().includes(searchTxt))
                    )
                } else {
                    return this.$store.getters.getDeliveries
                }
            },
            responseDate() {
                return this.$store.getters.getResponseDate
            },
            codeSearchResults() {
                return this.$store.getters.getCodeSearchResults
            },
            codeSearchQuery() {
                return this.$store.getters.getCodeSearchQuery
            },
            codeSearchStatus() {
                return this.$store.getters.getCodeSearchStatus
            },
            totalDeliveries() {
                return this.$store.getters.getTotalDeliveries
            },
            totalDelivered() {
                return this.$store.getters.getTotalDelivered
            },
            toDelivery() {
                return parseInt(this.totalDeliveries - this.totalDelivered)
            },
            timeNow() {
                return this.$store.getters.getTimeNow
            }
        },
        methods: {
            setSearch(bool) {
                this.search = bool;
                let vm = this
                setTimeout(function () {
                    if (bool && vm.$refs.searchInput) {
                        vm.$refs.searchInput.focus();
                    }
                }, 100)

            }
        },
        created() {
            this.$store.dispatch('fetchDeliveries')
        }

    }
</script>

<style lang="sass" scoped>
    .section
        padding-bottom: 50vh
    .search
        position: relative
        &__close
            transform: translateY(10px)
        &__input
            position: absolute
            right: calc( 100% + 20px )
            height: 40px
            top: 0
            z-index: 1
            width: calc( 100vw - 220px )
            border: none
            border-bottom: 1px solid #69b200
            text-align: center
            transition: transform 600ms
            will-change: transform
            &::placeholder
                color: #69b200
                opacity: .8
    .code-search-container
        position: static
        margin-bottom: 0.5rem
    .code-search-results-header
        margin-bottom: 0.75rem
        padding-bottom: 0.5rem
        border-bottom: 1px solid #dad9d8
        .tag
            margin-left: 0.5rem
</style>
